import { Button, cn } from "@devhop/ui";
import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";

type OrderDetailHeaderProps = {
  title: string;
  subtitle?: string;
  onBack: () => void;
  badges?: ReactNode;
  className?: string;
};

export function OrderDetailHeader({
  title,
  subtitle,
  onBack,
  badges,
  className,
}: OrderDetailHeaderProps) {
  return (
    <div
      className={cn(
        "shrink-0 border-b bg-card/80 px-4 py-3 backdrop-blur supports-backdrop-filter:bg-card/60",
        className,
      )}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <Button
            variant="outline"
            size="icon"
            className="h-10 w-10 shrink-0 rounded-xl"
            onClick={onBack}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div className="min-w-0">
            <h1 className="truncate font-heading font-bold text-xl lg:text-2xl">
              {title}
            </h1>
            {subtitle && (
              <p className="truncate text-muted-foreground text-sm">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {badges && (
          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            {badges}
          </div>
        )}
      </div>
    </div>
  );
}
